export default __webpack_public_path__ + "static/membership-current-bd977b21010716219ae1f8fd6946a7bc.jpg";